// Labels/cores do status do Borderô, centralizados aqui (padrão usado em Acordos —
// agreementStatusOptions.ts — em vez do globalTranslate/globalBackground/globalColorText antigo,
// que não cobre os status novos suspenso/agendado sem colidir com outros módulos).
export const BORDERO_STATUS_LABELS: Record<string, string> = {
	open: "Aberto",
	provisioned: "Provisionado",
	paid: "Pago",
	canceled: "Cancelado",
	suspended_sinistro: "Suspenso Sinistro",
	suspended_financeiro: "Suspenso Financeiro",
	scheduled_financeiro: "Agendado",
};

export const getBorderoStatusLabel = (status: string): string => BORDERO_STATUS_LABELS[status] ?? status;

export const getBorderoStatusChipColors = (status: string): { bg: string; color: string } => {
	switch (status) {
		case "open":
			return { bg: "#EBEDEF", color: "#5D6D7E" };
		case "provisioned":
			return { bg: "#def4ff", color: "#1F618D" };
		case "paid":
			return { bg: "#ddffe9", color: "#0f8a0d" };
		case "canceled":
			return { bg: "#ffdbdb", color: "#e40909" };
		case "suspended_sinistro":
		case "suspended_financeiro":
			return { bg: "#fdecea", color: "#c0392b" };
		case "scheduled_financeiro":
			return { bg: "#eef6ff", color: "#1565c0" };
		default:
			return { bg: "#ECECEC", color: "#757575" };
	}
};
